export default __webpack_public_path__ + "static/media/bg3.a5dda51d.png";